import BodyScanReportLight from "@/assets/img/body-report-light.webp";
import BodyScanReportLightDe from "@/assets/img/body-report-light-de.webp";
import BodyScanReportLightEs from "@/assets/img/body-report-light-es.webp";
import BodyScanReportLightFr from "@/assets/img/body-report-light-fr.webp";
import BodyScanReportLightPt from "@/assets/img/body-report-light-pt.webp";
import { Languages } from "@/constants/languages";

export const bodyScanReportImagesMap = {
    [Languages.English]: BodyScanReportLight,
    [Languages.Spanish]: BodyScanReportLightEs,
    [Languages.German]: BodyScanReportLightDe,
    [Languages.Portuguese]: BodyScanReportLightPt,
    [Languages.French]: BodyScanReportLightFr,
};
